<template>
  <section class="blogs">
    <b-container>
      <b-row>
        <b-col class="main_title">
          <h1 class="text-center">
            <strong>
  بعض المقالات الخاصة
            </strong>
            برحلات أجازة بوك
          </h1>
          <UnderLine/>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4" v-for="b in 3" :key="b" class="center-items-top">
          <SingleBlog/>
        </b-col>
      </b-row>
      <b-row>
        <div class="see-more">
           <b-button variant="primary">المزيد</b-button>
        </div>
      </b-row>
    </b-container>
  </section>
</template>
<script type="text/javascript">
import UnderLine  from '../global/UnderLine'
import SingleBlog from '../global/SingleBlog'
  export default {
    name :"Blog",
    components: {
      UnderLine,
      SingleBlog
    }
  }
</script>
